import * as React from 'react';

import { cn } from '@/lib/utils';

export type InputVariant = 'default' | 'transparent';

const inputBaseClass =
	'file:text-foreground placeholder:text-placeholder placeholder:font-light placeholder-shown:font-normal selection:bg-primary selection:text-primary-foreground bg-[#fafafa] dark:bg-slate-900 border-input flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base font-semibold shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm';

const inputTransparentClass = 'bg-transparent border-none shadow-none';

const inputFocusRingClass =
	'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]';

const inputInvalidClass =
	'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive';

interface InputProps extends React.ComponentProps<'input'> {
	variant?: InputVariant;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, variant = 'default', ...props }, ref) => {
		return (
			<input
				type={type}
				data-slot="input"
				className={cn(
					inputBaseClass,
					variant === 'transparent' && inputTransparentClass,
					inputFocusRingClass,
					inputInvalidClass,
					className
				)}
				ref={ref}
				{...props}
			/>
		);
	}
);

Input.displayName = 'Input';

export { Input, inputBaseClass, inputTransparentClass, inputFocusRingClass, inputInvalidClass };
